<template>
  <details :open="open" class="group py-2">
    <summary
      class="flex cursor-pointer items-center justify-between gap-3 py-3 text-left text-base font-semibold text-ink-strong marker:hidden focus-visible:outline-none focus-visible:shadow-[var(--shadow-ring-focus)] rounded"
      @click="onSummaryClick"
    >
      <span>{{ title }}</span>
      <BaseIcon
        name="chevron-down"
        :size="20"
        class="transition-transform duration-200 ease-[var(--ease-standard)] text-ink-muted"
        :class="[open ? 'rotate-180' : 'rotate-0']"
      />
    </summary>
    <div class="pb-3 pt-2 text-sm leading-6 text-ink">
      <slot />
    </div>
  </details>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { ACCORDION_KEY } from '@/components/feedback/accordion-context';
import { useId } from '@/composables/useId';

interface Props {
  id?: string | null;
  title: string;
  defaultOpen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  id: null,
  defaultOpen: false,
});

const emit = defineEmits<{
  (e: 'open', question: string): void;
}>();

const ctx = inject(ACCORDION_KEY, null);
const fallbackId = useId('accordion-item');
const itemId = computed(() => props.id ?? fallbackId);

const open = computed(() => (ctx ? ctx.isOpen(itemId.value) : props.defaultOpen));

function onSummaryClick(event: MouseEvent): void {
  if (!ctx) return;

  event.preventDefault();
  if (!ctx.isOpen(itemId.value)) emit('open', props.title);
  ctx.toggle(itemId.value);
}
</script>

<style scoped>
/* Скрываем нативный маркер <summary> (треугольник/диск): в шаблоне
   рендерим собственный chevron через <BaseIcon>. Через Tailwind это
   не выразить — нужен vendor-селектор ::-webkit-details-marker. */
summary::-webkit-details-marker {
  display: none;
}
</style>
